import {API_BASE_URL} from "@/config";

export async function setUserShiftStatus(userShiftId, status, getCsrfToken, fetchUserShifts, router) {
    try {
        const response = await fetch(
            `${API_BASE_URL}/user-shifts/${userShiftId}`,
            {
                method: 'PATCH',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCsrfToken(),
                },
                body: JSON.stringify({status}),
            }
        );
        if (response.status === 403) {
            router.push({name: 'forbidden'});
        } else if (response.status === 404) {
            this.$router.push({name: 'not-found'});
        } else {
            await fetchUserShifts();
        }
    } catch (error) {
        console.error('Error setting user shift status:', error);
    }
}

export async function deleteUserShift(userShiftId, getCsrfToken, fetchUserShifts, router) {
    try {
        const response = await fetch(
            `${API_BASE_URL}/user-shifts/${userShiftId}`,
            {
                method: 'DELETE',
                credentials: 'include',
                headers: {
                    'X-CSRFToken': getCsrfToken(),
                },
            }
        );
        if (response.status === 403) {
            router.push({name: 'forbidden'});
        } else if (response.status === 404) {
            router.push({name: 'not-found'});
        } else {
            await fetchUserShifts();
        }
    } catch (error) {
        console.error('Error deleting user shift:', error);
    }
}